import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './styles/global.scss'
import './styles/common.scss'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { store } from './app/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './console-filter';

const root = ReactDOM.createRoot(document.getElementById('root'));

const CLIENT_ID = process.env.REACT_APP_GAUTH_CLIENT_ID;

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
